// Theme names, the key we persist under, and the attribute the stylesheets key
// off. The same strings are needed by the inline boot script in
// public/index.html, which runs before the bundle exists and so cannot import
// from here — if you change a value, change it there too.

export const THEME_LIGHT = "light";
export const THEME_DARK = "dark";

// The only two values there are: one of them is always what lands on
// <html data-theme>, so a preference never needs resolving against anything.
export const THEMES = [THEME_LIGHT, THEME_DARK];

export const THEME_STORAGE_KEY = "app-theme";

export const THEME_ATTRIBUTE = "data-theme";

// What a first-time visitor gets. The OS setting is deliberately not consulted:
// the picker offers light and dark only, so "why is it dark when the toggle
// says nothing about my Mac" is a question no one has to ask.
export const DEFAULT_THEME = THEME_LIGHT;

// Dark is off for now: the switch is hidden and every screen paints light,
// whatever an earlier visit left in storage. Flip this back to true to bring
// the picker back — nothing else has to change, and a preference saved before
// this was turned off is still there when it returns.
//
// The boot script in public/index.html makes the same decision a beat earlier;
// it can't import from here, so switch it back there too.
export const THEME_PICKER_ENABLED = false;
